<template>
  <div class="mail-box-header">
    <table class="table table-hover table-mail">
      <thead class="table-head">
        <tr>
          <th>Tipo</th>
          <th>Nome</th>
          <th>Valor</th>
          <th>Descrição</th>
          <th>Data de pagamaento</th>
          <th>Pago</th>
          <th></th>
          <th></th>
        </tr>
      </thead>

      <tbody class="table-list">
        <tr v-for="(moviment, listIdx) in movementsArray" :key="listIdx">
          <td>{{ moviment.movementType }}</td>
          <td>{{ moviment.name }}</td>
          <td>{{ totalToCurrencyBR(moviment.amount) }}</td>
          <td>{{ moviment.description }}</td>
          <td>{{ DateBR(moviment.paidAt) }}</td>
          <td>{{ moviment.isPaid ? 'Sim' : 'Não' }}</td>
          <td class="list-command">
            <button
              type="button"
              class="btn btn-outline"
              @click.stop="enterEditMode(moviment, listIdx)"
              v-if="permissionToChange(moviment)"
            >
              <i class="fa fa-edit text-success"></i>
            </button>
          </td>
          <td class="list-command">
            <button
              type="button"
              class="btn btn-outline"
              @click.stop="remove(listIdx)"
              v-if="permissionToChange(moviment)"
            >
              <i class="fa fa-trash text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <form v-on:submit.prevent="addMovement" v-if="showForm">
      <h4>Tipo</h4>
      <div class="row">
        <div class="col-md-6">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              :value="1"
              v-model="form.movementType"
            />
            <label> Entrada</label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              :value="0"
              v-model="form.movementType"
            />
            <label> Saida</label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Nome</label>
        <input class="form-control" type="text" v-model="form.name" />
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Descrição</label>
            <input
              class="form-control"
              type="text"
              v-model="form.description"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Valor</label>
            <input
              v-model="form.amount"
              class="form-control"
              type="number"
              step="0.01"
              value="0.00"
              placeholder="0.00"
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Data de pagamento</label>
        <input
          class="form-control"
          type="datetime-local"
          v-model="form.paidAt"
          placeholder="Placa"
        />
      </div>
      <div class="form-check">
        <input type="checkbox" class="form-check-input" v-model="form.isPaid" />
        <label class="form-check-label checkboxlabel">Pago</label>
      </div>

      <button
        v-if="!control.editMode"
        type="submit"
        class="btn btn-block btn-primary compose-mail"
      >
        Adicionar Movimento
      </button>

      <div v-if="control.editMode">
        <button
          type="button"
          class="btn btn-outline"
          href="mail_compose.html"
          @click="exitEditMode"
        >
          Cancelar
        </button>

        <button
          type="button"
          class="btn btn-warning pull-right"
          href="mail_compose.html"
          @click="saveMovement"
        >
          <i class="fa fa-save"></i>
          Salvar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: Array,
    },
    showForm: Boolean,
  },
  data() {
    return {
      form: {
        movementType: 1,
        name: '',
        amount: '',
        description: '',
        paidAt: '',
        isPaid: false,
      },
      control: {
        editMode: false,
        movementId: '',
      },
      movementsArray: this.value,
    };
  },

  watch: {
    value: {
      handler(v) {
        this.movementsArray = v;
      },
    },
    movementsArray(v) {
      this.$emit('movements', v);
    },
  },

  methods: {

    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },

    DateBR(dt) {
      if (!dt) return '';
      return new Date(dt).toLocaleString('pt-br');
    },
    permissionToChange(item) {
      return !item.isPaid && this.showForm;
    },
    remove(id) {
      this.movementsArray.splice(id, 1);
    },
    enterEditMode(item, listIdx) {
      this.control.editMode = true;
      this.control.movementId = listIdx;
      this.form.name = item.name;
      this.form.amount = item.amount;
      this.form.description = item.description;
      this.form.paidAt = item.paidAt;
      this.form.isPaid = item.isPaid;
    },
    exitEditMode() {
      this.control.editMode = false;
      this.control.movementId = '';
      this.form.name = '';
      this.form.amount = '';
      this.form.description = '';
      this.form.paidAt = '';
      this.form.isPaid = false;
    },
    saveMovement() {
      const movents = this.movementsArray;
      movents[this.control.movementId] = { ...this.form };
      this.movementsArray = movents;
      this.exitEditMode();
    },
    addMovement() {
      const payload = {
        ...this.form,
        paidAt: this.form.paidAt || undefined,
        amount: this.form.amount * 100,
      };

      this.movementsArray.push(payload);
      this.exitEditMode();
    },
  },
};
</script>